/* Native details keeps click/touch/keyboard navigation working without this enhancement. */
if (!customElements.get('gl-mega-nav')) {
  customElements.define('gl-mega-nav', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.menus = [...this.querySelectorAll('details.gl-mega')];
      this.timers = new Map();
      this.menus.forEach((details) => {
        const summary = details.querySelector('summary');
        const container = details.closest('header-menu');
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
          if (details.open) {
            this.menus.forEach((other) => { if (other !== details) this.closeMenu(other); });
            this.updatePosition();
          }
          this.updateStickyState();
        }, options);
        container.addEventListener('pointerenter', (event) => {
          if (this.dataset.hover !== 'true' || event.pointerType !== 'mouse') return;
          clearTimeout(this.timers.get(details));
          // Do not steal a menu from somebody navigating its links with a keyboard.
          if (this.menus.some((other) => other !== details && other.open && other.contains(document.activeElement))) return;
          this.timers.set(details, setTimeout(() => { details.open = true; }, 100));
        }, options);
        container.addEventListener('pointerleave', () => {
          clearTimeout(this.timers.get(details));
          this.timers.set(details, setTimeout(() => {
            if (!details.contains(document.activeElement)) this.closeMenu(details);
          }, 220));
        }, options);
        details.querySelector('[data-gl-close]').addEventListener('click', () => {
          this.closeMenu(details);
          summary.focus();
        }, options);
      });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const active = this.menus.find((details) => details.open);
        if (active) {
          event.preventDefault();
          this.closeMenu(active);
          active.querySelector('summary').focus();
        }
      }, options);
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) this.menus.forEach((details) => this.closeMenu(details));
      }, options);
      window.addEventListener('resize', () => {
        if (window.innerWidth < 990) this.menus.forEach((details) => this.closeMenu(details));
        this.updatePosition();
      }, options);
      window.addEventListener('scroll', () => {
        if (this.menus.some((details) => details.open)) this.updatePosition();
      }, { ...options, passive: true });
    }
    closeMenu(details) {
      clearTimeout(this.timers.get(details));
      details.open = false;
      details.querySelector('summary').setAttribute('aria-expanded', 'false');
    }
    updateStickyState() {
      const wrapper = this.closest('.header-wrapper');
      if (wrapper) wrapper.preventHide = this.menus.some((details) => details.open);
    }
    updatePosition() {
      const row = this.closest('.header__nav-row');
      if (row) this.style.setProperty('--gl-menu-top', `${Math.max(0, row.getBoundingClientRect().bottom)}px`);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.timers?.forEach(clearTimeout);
      this.controller = null;
      const wrapper = this.closest('.header-wrapper');
      if (wrapper) wrapper.preventHide = false;
    }
  });
}
